import React, { useEffect, useRef, useState } from 'react'
import Svg from "./Svg";

export const isMuurikka = document.body.classList.contains('site-muurikka');

const stickyClass = 'is-sticky';

/**
 * @type {HTMLElement}
 */
let header = document.querySelector('header.header');

/**
 * @type {HTMLElement}
 */
// let shippingBar = header.querySelector('.shipping-bar__header');

// debugger;

/**
 * @return void
 */
const headerOnScroll = () => {
    if (document.documentElement.scrollTop === 0) {
        header.classList.remove(stickyClass);
    } else {
        header.classList.add(stickyClass);
    }
}

window._scrollTimeout = 0;
window.addEventListener('scroll', () => {
    if (window._scrollTimeout) {
        clearTimeout(window._scrollTimeout);
    }

    window._scrollTimeout = setTimeout(() => {
        headerOnScroll();
    }, 5);
})

window.addEventListener('DOMContentLoaded', headerOnScroll)


const MiscellaneousMenu = () => {
    const [open, setOpen] = useState(false);
    let burgerBtn = useRef();

    /**
     * @param {Event|null} e
     * @param {boolean} forceClose
     */
    function toggleMenu(e = null, forceClose = false) {
        e && e.preventDefault();

        const header = document.querySelector('header.header');
        const navbar = document.querySelector('header.header .navbar');
        let opened = document.querySelectorAll('.miscellaneous-menu__container .navbar__link--expand').length > 0;

        let clickedADifferentMenu = navbar.contains(e.target);
        document.querySelectorAll('.navbar__link--expand').forEach(item => {
            const parentIsNotNav = e && e.target && !e.target.parentElement.classList.contains('navbar__link--expand');
            if (parentIsNotNav) {
                item.classList.remove('navbar__link--expand');
            }
        });

        if (forceClose || opened) {
            !clickedADifferentMenu && header.classList.remove('menu-open');
            document.getElementById('miscellaneous-menu').classList.remove('navbar__link--expand');
            setOpen(false);
        } else {
            header.classList.add('menu-open');
            document.getElementById('miscellaneous-menu').classList.add('navbar__link--expand');
            setOpen(true);
        }
    }

    useEffect(() => {
        function miscellaneousClickHandler(e) {
            const containerEl = document.querySelector('.miscellaneous-menu__container');

            if (!open || e.target === containerEl || containerEl.contains(e.target)) {
                return;
            }

            // If open, we toggle (close)
            toggleMenu(e, true);
        }

        document.addEventListener('click',miscellaneousClickHandler);
        return () => document.removeEventListener('click',miscellaneousClickHandler);
    }, [open]);

    return <span ref={burgerBtn} onClick={toggleMenu}>
        <Svg icon="hamburger" label="Open menu" />
        <Svg icon="close" label="Close menu" />
    </span>
}

export default MiscellaneousMenu
